import { type EmbedTargetType } from './embed-target'
import { HtmlMediaElementControls } from '../media/HtmlMediaControls'
import { type MediaControls } from '../media'
import { type DetectEmbedTargetsOptions, type EmbedTargetFactory } from './embed-target-factory'
import { BaseEmbedTarget } from './base'
import { type EmbedBeforeCreateElementContext, type EmbedElementContext } from '../element-embedder'
import { type IFrameEmbedHandler } from '../embed-strategies/iframe/IFrameEmbedStrategy'
import { TargetAsParentStrategyHandler } from '../embed-strategies/iframe/ParentStrategyHandler'
import { FloatStrategyHandler } from '../embed-strategies/iframe/FloatStrategyHandler'

function findMediaElement (el: Element): HTMLMediaElement | undefined {
  if (el instanceof HTMLMediaElement) return el
  const videoEl = el.querySelector('video')
  if (videoEl != null) return videoEl
  const audioEl = el.querySelector('audio')
  if (audioEl != null) return audioEl
  return undefined
}

/**
 * TODO: this can support any html block element. Expand its support
 */
export class DivEmbedTargetFactory implements EmbedTargetFactory<DivEmbedTarget> {
  name: EmbedTargetType = 'div'
  supports (ctx: EmbedBeforeCreateElementContext): boolean {
    return ctx.targetEl.tagName === 'DIV'
  }

  create (ctx: EmbedElementContext): DivEmbedTarget {
    return new DivEmbedTarget(ctx)
  }

  detectFromDom (_opts?: DetectEmbedTargetsOptions): HTMLElement[] {
    return []
  }
}

export class DivEmbedTarget extends BaseEmbedTarget {
  protected getIFrameEmbedHandler (): IFrameEmbedHandler {
    const strategy = this.ctx.settings.strategy
    if (strategy === 'parent') return new TargetAsParentStrategyHandler(this)
    else if (strategy === 'float-absolute' || strategy === 'float-fixed') return new FloatStrategyHandler(this)
    throw new Error(`Invalid strategy ${strategy as string}`)
  }

  mediaControl?: MediaControls

  constructor (ctx: EmbedElementContext) {
    super('div', ctx)
    const mediaElement = findMediaElement(this.ctx.targetEl)
    if (mediaElement != null) this.mediaControl = new HtmlMediaElementControls(mediaElement)
  }

  get bottomSpace (): string {
    return this.ctx.settings.bottomSpace ?? '0px'
  }

  /**
   * No need to implement for div embedder
   * @param _value
   */
  setPlaysInline (_value: boolean): void { }
}
